var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4375 3.28125H16.4062C17.1311 3.28125 17.7188 3.86888 17.7188 4.59375V18.375C17.7188 19.0999 17.1311 19.6875 16.4062 19.6875H4.59375C3.86888 19.6875 3.28125 19.0999 3.28125 18.375V4.59375C3.28125 3.86888 3.86888 3.28125 4.59375 3.28125H6.5625V2.625C6.5625 1.90013 7.15013 1.3125 7.875 1.3125H13.125C13.8499 1.3125 14.4375 1.90013 14.4375 2.625V3.28125ZM13.125 2.625H7.875V5.25H13.125V2.625ZM16.4062 18.375H4.59375V4.59375H6.5625V6.5625H14.4375V4.59375H16.4062V18.375ZM6.5625 9.1875H7.875V15.75H6.5625V9.1875ZM14.4375 11.8125H13.125V15.75H14.4375V11.8125ZM11.1562 13.125H9.84375V15.75H11.1562V13.125Z",
    fill: "rgb(14,37,106)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/Projects.ad6f0de254858a05229a6df2a8602fb7.svg";
export { ForwardRef as ReactComponent };